import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/dist/query/react";
import { baseUrl } from "../constant";

const betAdminBaseQuery = fetchBaseQuery({
  baseUrl,
  prepareHeaders: (headers) => {
    const token = localStorage.getItem("token");
    if (token) headers.set("Authorization", `Bearer ${token}`);
    return headers;
  },
});

export const betSettlementApi = createApi({
  reducerPath: "betSettlementApi",
  baseQuery: betAdminBaseQuery,
  tagTypes: ["OpenBets"],
  endpoints: (build) => ({
    adminOpenBets: build.query({
      query: (matchId) => ({
        url: "/bet/admin/open-bets",
        method: "POST",
        body: matchId ? { matchId } : {},
      }),
      providesTags: ["OpenBets"],
    }),
    adminSettleFancy: build.mutation({
      query: (body) => ({
        url: "/bet/admin/settle-fancy",
        method: "POST",
        body,
      }),
      invalidatesTags: ["OpenBets"],
    }),
    adminSettleMatch: build.mutation({
      query: (body) => ({
        url: "/bet/admin/settle-match",
        method: "POST",
        body,
      }),
      invalidatesTags: ["OpenBets"],
    }),
    adminUpdateOpenBet: build.mutation({
      query: (body) => ({
        url: "/bet/admin/m-patch",
        method: "POST",
        body,
      }),
      invalidatesTags: ["OpenBets"],
    }),
    adminVoidOpenBet: build.mutation({
      query: (body) => ({
        url: "/bet/admin/m-drop",
        method: "POST",
        body,
      }),
      invalidatesTags: ["OpenBets"],
    }),
    adminPlaceForClient: build.mutation({
      query: (body) => ({
        url: "/bet/admin/m-place",
        method: "POST",
        body,
      }),
      invalidatesTags: ["OpenBets"],
    }),
    adminSearchClients: build.query({
      query: (term = "") => ({
        url: "/user/username-id-search",
        method: "POST",
        body: { userType: 2, term: term || "" },
      }),
    }),
    adminRunAutoSettle: build.mutation({
      query: () => ({
        url: "/bet/admin/run-auto-settle",
        method: "POST",
        body: {},
      }),
      invalidatesTags: ["OpenBets"],
    }),
  }),
});

export const {
  useAdminOpenBetsQuery,
  useAdminSettleFancyMutation,
  useAdminSettleMatchMutation,
  useAdminUpdateOpenBetMutation,
  useAdminVoidOpenBetMutation,
  useAdminPlaceForClientMutation,
  useAdminSearchClientsQuery,
  useAdminRunAutoSettleMutation,
} = betSettlementApi;
